<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-full"
          src="img/impaxrx-logo.png"
          width="89"
          height="32"
          alt="ImpaxRx"
        />
        <img
          class="navbar-brand-minimized"
          src="img/impaxrx-icon.png"
          width="21"
          height="30"
          alt="ImpaxRx"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
        <!--
        <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>
        <b-nav-item class="px-3" to="/settings">Settings</b-nav-item>
        -->
      </b-navbar-nav>
      <b-navbar-nav style="margin-left: 15px;" class="d-md-down-none ml-auto">
        <b-nav-item class="d-md-down-none">
          <DefaultSettingsDropdown />
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdown />
        </b-nav-item>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="navItems" style="background-color: #3FA6B7"></SidebarNav>
        <SidebarFooter style="background-color: #3FA6B7" />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb v-if="list.length" :list="list" />
        <div class="container-fluid p-0">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <span class="ml-1">ImpaxRx &copy; 2020</span>
      </div>
      <!-- <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>
      </div>-->
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav';
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  Footer as TheFooter,
  Breadcrumb
} from '@coreui/vue';
import DefaultAside from './DefaultAside';
import DefaultHeaderDropdown from './DefaultHeaderDropdown';
import DefaultSettingsDropdown from './DefaultSettingsDropdown';

export default {
  name: 'DefaultContainer',
  components: {
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    DefaultSettingsDropdown
  },
  data() {
    return {
      navItems: nav.items
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  }
};
</script>
<style scoped>
.sidebar-nav,
.sidebar-minimizer {
  background-image: linear-gradient(
    to bottom,
    #009999 1%,
    #66cccc 49%,
    #006699 100%
  );
}
</style>
